import { render, staticRenderFns } from "./ClassifierImage.vue?vue&type=template&id=663bf025&"
import script from "./ClassifierImage.vue?vue&type=script&lang=ts&"
export * from "./ClassifierImage.vue?vue&type=script&lang=ts&"
import style0 from "./ClassifierImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports